import { useAmplitude } from 'hooks/useAmplitude';
import { useAppContext } from 'hooks/useAppContext';
import { useParams } from 'react-router-dom';
import { getSearchTrucker } from 'services/searchTrucker';
import { useTracking } from '../useTracking';

const useSearchTrucker = () => {
  const { dispatch } = useAppContext();
  const { sendAmplitude } = useAmplitude();
  const { sendTracking } = useTracking();

  const { freightId = 'j3ZlGd' } = useParams();

  const typeOfSearched = (isCpf: boolean, truckerId?: string) => {
    if (isCpf) return 'cpf';
    if (!!truckerId) return 'telefone';
    return 'nao-disponivel';
  };

  const searchTrucker = async (term: string) => {
    dispatch({ type: 'search_truckers_load' });

    try {
      const response = await getSearchTrucker(freightId, term);

      sendAmplitude('trucker_listing_search_driver', {
        value: term,
        freightCode: freightId,
        driver: !!response?.trucker?.id ? [response.trucker.id] : 'motorista-fora-base',
        type: typeOfSearched(response?.wasSearchedByCpf, response?.trucker?.id),
        source: 'lista-motorista',
      });
      sendTracking({
        url: window.location.href,
        referrer: document.referrer,
        event: {
          name: `trucker_listing_search_driver`,
        },
        data: {
          value: term,
          freightId: `hashed|${freightId}`,
          source: 'lista-motorista',
          driver: !!response?.trucker?.id ? [`hashed|${response.trucker.id}`] : 'motorista-fora-base',
          type: typeOfSearched(response?.wasSearchedByCpf, response?.trucker?.id),
        },
      });

      if (!!response) {
        sendAmplitude('trucker_listing_profile_visited', {
          source: 'BA_ListaMotorista',
          codeRegion: response?.trucker?.phones.map((phone) => phone.ddd),
          isVerified: response?.isVerified,
          truckerId: response?.trucker?.id,
          freightId,
          latestConsultations: 'normalconsultation',
          tag: 'N/A',
          destiny: 'N/A',
        });
      }

      dispatch({
        type: 'search_truckers_load_success',
        payload: response,
      });
    } catch (error) {
      dispatch({ type: 'search_truckers_load_error', payload: error.message });
    }
  };

  return { searchTrucker };
};

export { useSearchTrucker };
